'use client';

import { ROBOT_MODEL } from 'types/models';

import { useModelName } from 'lib/api/myRobot';

import {
  RobotManufacturerEnum,
  RobotModelEnum,
  RobotTypeEnum,
} from 'lib/ros-abstraction/types';
import { getModelConfigByName } from 'lib/ros-abstraction/registry';

// ─── Hook ────────────────────────────────────────────────────────────────────

export type RobotIdentity = {
  robotModel: RobotModelEnum;
  robotType: RobotTypeEnum;
  manufacturer: RobotManufacturerEnum;
  modelName: ROBOT_MODEL;
  usesRosAbstraction: boolean;
  isRobotType: (type: RobotTypeEnum) => boolean;
  isRobotModel: (model: RobotModelEnum) => boolean;
};

/**
 * Resolves the full robot identity (type, model, manufacturer) from
 * the currently selected robot's model name.
 *
 * Replaces scattered `isSpot/isDrone` boolean checks with a structured identity.
 */
export function useRobotIdentity(): RobotIdentity {
  const { modelName } = useModelName();
  const config = getModelConfigByName(modelName);

  return {
    robotModel: config.robotModel,
    robotType: config.robotType,
    manufacturer: config.manufacturer,
    modelName,
    usesRosAbstraction: config.usesRosAbstraction,
    isRobotType: (type: RobotTypeEnum) => config.robotType === type,
    isRobotModel: (model: RobotModelEnum) => config.robotModel === model,
  };
}

export function useIsWearable(): boolean {
  const { isRobotType } = useRobotIdentity();
  return isRobotType(RobotTypeEnum.Wearable);
}
